module.exports = __webpack_public_path__ + "static/media/orders_count.ef244573.svg";